/**
 * @fileoverview Funciones auxiliares para ProcesoGastoMenor
 * 
 * Genera los campos del formulario de gastos menores
 * siguiendo el patrón de FuncionesProcesoCompra.js
 * 
 * @author OmniERP
 * @version 1.0.0
 */

const FuncionesProcesoGastoMenor = () => {

  /**
   * Genera la configuración de campos para el formulario de gastos menores
   * 
   * @param {Array} tiposEgreso - Lista de tipos de egreso
   * @param {Array} cuentasTesoreria - Lista de cuentas de tesorería
   * @param {Array} metodosPago - Lista de métodos de pago
   * @returns {Array} - Configuración de campos del formulario
   */
  function generarCamposFormulario(tiposEgreso = [], cuentasTesoreria = [], metodosPago = []) {
    return [
      // Sección: Comprobante fiscal
      {
        id: "ncf",
        type: "text",
        label: "NCF",
        placeholder: "Se asignará automáticamente",
        seccion: "Comprobante fiscal",
        disabled: true
      },

      // Sección: Información general
      {
        id: "usuario",
        type: "text",
        label: "Creado por:",
        placeholder: "Usuario",
        seccion: "Información general",
        disabled: true
      },
      {
        id: "concepto",
        type: "text",
        label: "Concepto",
        placeholder: "Ej: Parqueo reunión cliente",
        seccion: "Información general"
      },
      {
        id: "id_tipo_egreso",
        type: "select",
        label: "Tipo de Egreso",
        placeholder: "Seleccione tipo",
        seccion: "Información general",
        options: tiposEgreso.map(tipo => ({
          label: tipo.descripcion,
          value: tipo.id_tipo_egreso
        }))
      },
      {
        id: "id_cuenta_tesoreria",
        type: "select",
        label: "Cuenta Tesorería",
        placeholder: "Seleccione cuenta",
        seccion: "Información general",
        options: cuentasTesoreria.map(cuenta => ({
          label: cuenta.descripcion,
          value: cuenta.id_cuenta_tesoreria
        }))
      },
      {
        id: "id_metodo_pago",
        type: "select",
        label: "Método de Pago",
        placeholder: "Seleccione método",
        seccion: "Información general",
        options: metodosPago.map(metodo => ({
          label: metodo.descripcion,
          value: metodo.id_metodo_pago
        }))
      },
      {
        id: "fecha_hora",
        type: "datetime-local",
        label: "Fecha y hora",
        placeholder: "Fecha y hora del gasto",
        seccion: "Información general"
      },

      // Sección: Comentario
      {
        id: "comentario",
        type: "textarea",
        placeholder: "Comentario adicional...",
        seccion: "Comentario"
      },

      // Sección: Totales (solo lectura)
      {
        id: "monto_total",
        type: "number",
        label: "Monto Total",
        placeholder: "0.00",
        seccion: "Totales",
        disabled: true
      }
    ];
  }

  /**
   * Campos para la tabla dinámica de detalles de egreso
   */
  const camposDetalleEgreso = [
    {
      name: "descripcion",
      label: "Descripción",
      placeholder: "Descripción del gasto",
      type: "text",
      required: true
    },
    {
      name: "cantidad",
      label: "Cantidad",
      placeholder: "1",
      type: "number",
      min: 1,
      defaultValue: 1
    },
    {
      name: "monto",
      label: "Monto",
      placeholder: "0.00",
      type: "number",
      min: 0,
      step: "0.01"
    },
    {
      name: "total",
      label: "Total",
      placeholder: "0.00",
      type: "number",
      disabled: true
    }
  ];

  /**
   * Calcula el total de un detalle de egreso
   * @param {Object} detalle - Detalle del egreso
   * @returns {number} - Total calculado
   */
  function calcularTotalDetalle(detalle) {
    const cantidad = parseFloat(detalle.cantidad) || 1;
    const monto = parseFloat(detalle.monto) || 0;
    return cantidad * monto;
  }

  /**
   * Calcula los totales del egreso desde los detalles (E43 no maneja impuestos)
   * @param {Array} detalles - Array de detalles
   * @returns {Object} - { monto, monto_total }
   */
  function calcularTotalesEgreso(detalles) {
    let monto = 0;
    let monto_total = 0;

    (detalles || []).forEach(det => {
      const cantidad = parseFloat(det.cantidad) || 1;
      const montoUnitario = parseFloat(det.monto) || 0;
      const total = parseFloat(det.total) || (cantidad * montoUnitario);

      monto += (cantidad * montoUnitario);
      monto_total += total;
    });

    return {
      monto: monto.toFixed(2),
      monto_total: monto_total.toFixed(2)
    };
  }

  return {
    generarCamposFormulario,
    camposDetalleEgreso,
    calcularTotalDetalle,
    calcularTotalesEgreso
  };
};

export default FuncionesProcesoGastoMenor;

